import { updateContextAction } from "./updateContext.action";
import { MAP_CONFIG_LOADED } from "../../../../MapStore2/web/client/actions/config";
import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { Action } from "redux";
import { RootState } from "../../../rootState";
import { CONTEXT_BASELINE, CONTEXT_WORKSPACE } from "../../changesConstants";

export const contextEpic: EpicFactory<Action, RootState, Action> = (action, store) =>
    action.ofType(MAP_CONFIG_LOADED).map(() => {
        const state = store.getState();

        return updateContextAction(state.urlParams.slots.haveSlotIds() ? CONTEXT_WORKSPACE : CONTEXT_BASELINE);
    });
